import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "label", "filename"]

  dragover(event) {
    event.preventDefault()
    this.labelTarget.classList.add("border-emerald-500", "bg-emerald-50")
    this.labelTarget.classList.remove("border-gray-300", "bg-gray-50")
  }

  dragleave(event) {
    event.preventDefault()
    this.removeHighlight()
  }

  drop(event) {
    event.preventDefault()
    this.removeHighlight()

    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.inputTarget.files = files
      this.filenameTarget.textContent = files[0].name
    }
  }

  removeHighlight() {
    this.labelTarget.classList.remove("border-emerald-500", "bg-emerald-50")
    this.labelTarget.classList.add("border-gray-300", "bg-gray-50")
  }
}
